import { defineStore } from 'pinia'
import { fetchAdminSystemWallets } from '@/entities/admin/api/adminWalletsApi'

export function systemEntityLabel(byId, id) {
  return byId[String(id ?? '').trim()]?.name ?? ''
}

export const useAdminSystemWalletsStore = defineStore('adminSystemWallets', {
  state: () => ({
    walletById: {},
    accountById: {},
    isLoading: false,
    error: null,
    hasLoaded: false,
  }),

  actions: {
    clear() {
      this.walletById = {}
      this.accountById = {}
      this.isLoading = false
      this.error = null
      this.hasLoaded = false
    },

    async fetchSystemWallets({ force = false } = {}) {
      if (this.isLoading || (this.hasLoaded && !force)) {
        return
      }

      this.isLoading = true
      this.error = null

      try {
        const { walletById, accountById } = await fetchAdminSystemWallets()
        this.walletById = walletById
        this.accountById = accountById
        this.hasLoaded = true
      } catch (error) {
        this.error = error
        this.walletById = {}
        this.accountById = {}
      } finally {
        this.isLoading = false
      }
    },
  },
})
